import { getAddress } from "viem";

export const safeGetAddress = (address: string) => {
  try {
    const checksummedAddress = getAddress(address.toLowerCase());
    return checksummedAddress;
  } catch {
    return null;
  }
};
